<div class="card">
  <p-menubar [model]="items">
    <ng-template pTemplate="start">
      <img
        src="assets/logo.png"
        alt="TotalEnergies Logo"
        height="60"
        style="cursor:pointer"
      />
    </ng-template>

    <ng-template pTemplate="end">
      <div style="display: flex">
        <button *ngIf="!(isLoggedIn$ | async); else logged"
                pButton type="button" class="p-button-text p-button-sm mt-1"
                (click)="login()">
          <span pButtonLabel>Login</span>
        </button>
        <ng-template #logged>
          <button pButton type="button" class="p-button-text p-button-sm mt-1"
                  (click)="logout()">
            <span pButtonLabel>Logout</span>
          </button>
        </ng-template>

        <button pButton type="button" class="p-button-text"
                (click)="toggleDarkMode()">
          <i *ngIf="!darkMode" pButtonIcon class="pi pi-moon" title="Dark mode"></i>
          <i *ngIf="darkMode" pButtonIcon class="pi pi-sun" title="Light mode"></i>
        </button>

        <div class="app-title">
          <div class="name">Flash Up</div>
          <div class="version">v1.0.0</div>
        </div>
      </div>
    </ng-template>

    <ng-template *ngIf="false" pTemplate="end">
      <div class="app-title">
        <div class="name">Flash Up</div>
        <div class="version">v1.0.0</div>
      </div>
    </ng-template>
  </p-menubar>
</div>

<router-outlet *ngIf="(isLoggedIn$ | async)"></router-outlet>
